import React, { Fragment } from 'react'
import G from '../../../../../../../util/globalFunction'
import * as R from 'ramda'

export default props => {
    const {
        spChkData, setSpChkData
        , spPrechkList = [], equipOperSpList = []
        , viewMode = false
    } = props
    const handleChangeData = (e, operSpSkey, reservAreaNo, equipSkey, maxAreaCount) => {
        let SP_LIST = spChkData

        if(e.target.checked) {
            const spObj = {
                OPER_SP_SKEY: operSpSkey,
                RESERV_AREA_NO: reservAreaNo,
                EQUIP_SKEY:  equipSkey
            }
            SP_LIST.push(spObj)
            // 최대예약패키지수
            if(!R.isNil(maxAreaCount)){
                let checkSpList = SP_LIST.filter(o=>o.EQUIP_SKEY == equipSkey)
                if(checkSpList.length > maxAreaCount){
                    alert(G.t('trem.lang.home.1044')+`${maxAreaCount}`+G.t('trem.lang.home.1045')) /* 예약가능한 패키지수는 ${maxAreaCount}개 입니다. */
                    SP_LIST = SP_LIST.filter(o => o.RESERV_AREA_NO != reservAreaNo)
                    e.target.checked = false
                }
            }
        } else {
            SP_LIST = SP_LIST.filter(o => o.RESERV_AREA_NO != reservAreaNo)
        }
        setSpChkData(SP_LIST)
    }

    return <Fragment>
         <div className="calendar_t">
            <ul className="reserv_calendar_color">
                {(!viewMode || spPrechkList.length != 0)
                    && <li><span className="c_color1"></span>{G.t('trem.lang.home.0010')}</li>/* 장비예약 */
                }
                <li><span className="c_color6"></span>{G.t('trem.lang.home.0087')}</li>{/* 현재 예약 구간 */}
            </ul>
        </div>
        <div className="r_select_box">
            <ul>
                {equipOperSpList.map((obj, index) => {
                    const operSpSkey = obj.OPER_SP_SKEY
                    const areaForm1 = obj.AREA_FORM1 || 0
                    const areaForm2 = obj.AREA_FORM2 || 0
                    const equipSkey = obj.EQUIP_SKEY
                    const maxAreaCount = obj.MAX_AREA_COUNT

                    const rendering = () => {
                        let result = []
                        let cnt = 0
                        for( let i=1; i<=areaForm1; i++) {
                            let resultsub = []
                            for( let j=1; j<=areaForm2; j++) {
                                const prechkFlag = spPrechkList.filter(o =>
                                    o.RESERV_AREA_NO === `${operSpSkey}-${i}-${j}`).length > 0
                                
                                const reservAreaNo = `${operSpSkey}-${i}-${j}`

                                let inputProps = {
                                    className: prechkFlag ? "prechk" : "chk",
                                    id: `RESERV_AREA_NO${reservAreaNo}`,
                                    value: reservAreaNo,
                                    disabled: prechkFlag,
                                    onChange: e => handleChangeData(e, operSpSkey, reservAreaNo, equipSkey, maxAreaCount)
                                }

                                if(viewMode) {
                                    const chkFlag = spChkData.filter(o => 
                                        o.RESERV_AREA_NO === reservAreaNo).length > 0

                                    inputProps['checked'] = chkFlag
                                    inputProps['disabled'] = viewMode
                                }

                                resultsub.push(
                                    <li key={j}>
                                        <input type="checkbox" title="예약구간 선택" {...inputProps}/>
                                        <label htmlFor={`RESERV_AREA_NO${reservAreaNo}`}>
                                            {areaForm2 * (i-1) + j < 10 ? '0' : ''}
                                            {areaForm2 * (i-1) + j}
                                        </label>
                                    </li>
                                )

                                cnt++
                            }

                            result.push(
                                <ul style={{display: "flex", flexWrap: "nowrap", width: "fit-content"}} key={i}>{resultsub}</ul>
                            )
                        }

                        return result
                    }

                    return <li key={index}>
                        <div className={`r_select r_select${obj?.AREA_FORM2}`}>
                            <div className="r_s_name">
                                <span>{obj?.NAME}</span>
                            </div>
                            <div className="r_select_b">
                                {rendering()}
                            </div>
                        </div>
                    </li>
                })}
            </ul>
        </div>
    </Fragment>
}